import CurrencyRateParametersWidgetWithoutStore from './components/widgets/CurrencyRateParametersWidgetWithoutStore.vue';

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    Vue.component("CurrencyRateParametersWidgetWithoutStore", CurrencyRateParametersWidgetWithoutStore);
  },
};
